import { CompProps } from '@fable/types'
import { Ref, forwardRef } from 'react'
import { StatsScreenshotFooter } from './StatsScreenshotFooter'
import { css, cx } from '@fable/theme'
import { useStatsTheme } from '../../../theme/ctx'

interface Props {
  className?: string
  backgroundColor?: string
  gradient?: string
  dev?: boolean
}

const Content = (
  { children, className = '', gradient, dev = false }: CompProps<Props>,
  ref: Ref<HTMLDivElement>
) => {
  const theme = useStatsTheme((s) => s.theme)

  return (
    <div
      className={css`
        position: fixed;
        top: 0;
        right: 0;
        z-index: -99999;
        opacity: ${dev ? 1 : 0};
        pointer-events: none;
      `}
    >
      <div
        ref={ref}
        className={cx(
          css`
            width: 380px;
            position: relative;
            padding-bottom: 60px;
            background-color: ${theme.colors.section.bg};
          `,
          className
        )}
      >
        {!!gradient?.length ? (
          <img
            src={gradient}
            alt="background gradient"
            className={css`
              display: block;
              width: 100%;
              height: 100%;
              background-size: cover;
              background-position: top;
              background-repeat: no-repeat;
              position: absolute;
              top: 0;
              left: 0;
              z-index: 0;
            `}
          />
        ) : null}
        <div
          className={css`
            padding: 20px;
            position: relative;
            z-index: 1;
            width: 100%;
          `}
        >
          {children}
        </div>
        <StatsScreenshotFooter />
      </div>
    </div>
  )
}

export const StatsScreenshot = forwardRef(Content)
